import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter, remoteOptionFormatter} from "../../../utils/formatters";
import {optionFilter} from "../../../utils/filters";

class CommissionPaymentList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "CommissionPaymentList"}
                {...props}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "commissioner.name": {
                        header: 'Partner',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "commission.provider": {
                        header: 'Típus',
                        width: 2,
                        sortable,
                        filterable: optionFilter("CommissionProvider"),
                        renderer: remoteOptionFormatter("CommissionProvider")
                    },
                    "fromdate": {
                        header: 'Dátumtól',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "todate": {
                        header: 'Dátumig',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "amount": {
                        header: 'Nettó összeg',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: CurrencyFormatter,
                        className: 'currency'
                    },
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default CommissionPaymentList;
